import { Box, SvgIconProps, Tooltip, useTheme } from '@mui/material';
import { Flag as FlagIcon } from 'react-feather';
import Flag from 'react-world-flags';
import IconFeather from 'src/components/common/Icon';
import { SUPPORT_MAPPING_COUNTRY_CODE_FOR_ICTTM_DATA } from 'src/utils/constants/countries';
import { getCountryByCountryCode } from 'src/utils/helpers/stringHelpers';

const FlagCountry = ({
  code,
  width = 16,
  colorDefaultFlag = '',
  iconProps = {},
  className = '',
}: {
  code?: string;
  width?: number;
  colorDefaultFlag?: string;
  iconProps?: SvgIconProps;
  className?: string;
}) => {
  const {
    shape: { borderRadius },
  } = useTheme();
  const countryCode =
    SUPPORT_MAPPING_COUNTRY_CODE_FOR_ICTTM_DATA[code as keyof typeof SUPPORT_MAPPING_COUNTRY_CODE_FOR_ICTTM_DATA] ||
    code;
  const countryName = getCountryByCountryCode(countryCode || '')?.label;

  return (
    <Tooltip title={countryName} arrow>
      <Box component={'span'} display="inline-flex" alignItems={'center'}>
        <Flag
          width={width}
          code={countryCode}
          className={className}
          fallback={
            <IconFeather
              muiProps={{ fontSize: 'small', color: 'disabled', sx: { color: colorDefaultFlag }, ...iconProps }}
              icon={<FlagIcon />}
            />
          }
        />
      </Box>
    </Tooltip>
  );
};

export default FlagCountry;
